
import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator';
import * as markdown from '../markdown';
import * as ui from '../ui';
import T from '../lang';

declare global {
  interface Window {
    MathJax?: {
      tex: any;
      startup: {
        typeset: boolean;
        elements?: HTMLElement[];
        ready: () => void;
        defaultReady?: () => void;
      };
      typeset?: (elements?: HTMLElement[]) => void;
      options: any;
      loader: any;
    };
  }
}

@Component
export default class Markdown extends Vue {
  @Prop() markdown!: string;
  @Ref() root!: HTMLElement;
  @Prop({ default: false }) fullWidth!: boolean;

  markdownConverter = new markdown.Converter();

  get html(): string {
    return this.markdownConverter.makeHtml(this.markdown);
  }

  mounted(): void {
    this.root.innerHTML = this.html;
    this.injectCopyButtons();
  }

  @Watch('markdown')
  onMarkdownChanged(): void {
    this.root.innerHTML = this.html;
    this.injectCopyButtons();
  }

  private injectCopyButtons(): void {
    if (!this.root) {
      return;
    }

    const codeElements = this.root.querySelectorAll('span > code');
    if (!codeElements.length) {
      return;
    }

    codeElements.forEach((element) => {
      const codeElement = element as HTMLElement;
      const parentSpan = codeElement.parentElement;
      if (!parentSpan) {
        return;
      }

      if (parentSpan.querySelector('.copy-btn')) {
        return;
      }

      const copyButton = document.createElement('button');
      copyButton.type = 'button';
      copyButton.className = 'btn btn-link btn-sm ml-2 copy-btn';
      copyButton.textContent = T.wordsCopyToClipboard;

      const copyHint = document.createElement('span');
      copyHint.className = 'copy-hint';
      copyHint.textContent = T.wordsCopiedToClipboard;

      copyButton.addEventListener('click', () => {
        const codeText = (codeElement.textContent || '').trim();
        ui.copyToClipboard(codeText);

        copyHint.classList.remove('fade-out');
        copyHint.classList.add('fade-in');

        window.setTimeout(() => {
          copyHint.classList.remove('fade-in');
          copyHint.classList.add('fade-out');
        }, 1500);
      });

      parentSpan.appendChild(copyButton);
      parentSpan.appendChild(copyHint);
    });
  }
}
